export default {"src":"/_next/static/media/0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b.9d7e9ac2.svg","height":139,"width":120,"blurWidth":0,"blurHeight":0};